<template>
    <div v-if="!alwaysShow">
        <button class="button slightly-rounded" @click="showMlRequest = !showMlRequest">Show Request Options</button>
        <br><br>
    </div>
    <span v-if="showMlRequest || alwaysShow">
        <RoundedContainer>
            <h2 class="has-text-centered mt-2 mb-5">ML Options</h2>
            <div class="field">
                <label class="label">Latitude</label>
                <input
                    class="input"
                    v-model="lat"
                    placeholder="latitude"
                >
            </div>
            <div class="field">
                <label class="label">Longitude</label>
                <input
                    class="input"
                    v-model="lon"
                    placeholder="Longitude"
                >
            </div>
            <div class="field mb-4">
                <label class="label">Week</label>
                <input
                    class="input"
                    v-model="week"
                    placeholder="Longitude"
                >
            </div>
        </RoundedContainer>
        <div class="buttons is-centered pt-1">
            <LoadingButton
                class="slightly-rounded"
                text="Request Detections"
                :loading="loading"
                bulma-color-class="is-primary"
                bulma-icon=""
                @clicked="postMlRequest">
            </LoadingButton>
        </div>
    </span>
</template>

<script>
import RoundedContainer from '@/widgets/RoundedContainer.vue'
import LoadingButton from '@/widgets/LoadingButton.vue'
import { processMl } from '/src/js/apis.js'

export default {
    name:'MlRequestOptions',
    components: {RoundedContainer, LoadingButton},
    props: [
        'requestingUser',
        'token',
        'soundIds',
        'alwaysShow',
    ],
    emits: ['MlReqComplete'],
    data() {
        return {
            lat: 51.180,
            lon: -2.825,
            week: 10,
            showMlRequest: false,
            loading: false,
        }
    },
    methods: {
        async postMlRequest(){
            this.loading = true
            const promises = []
            for (const id of this.soundIds){
                promises.push(
                    processMl(
                        this.requestingUser,
                        id,
                        parseFloat(this.lat),
                        parseFloat(this.lon),
                        parseInt(this.week),
                        this.token
                    )
                )
            }
            let responses = await Promise.all(promises)
            this.$emit('MlReqComplete', responses)
            this.showMlRequest = false
            this.loading = false
        }
    }
}
</script>

